import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to)
  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js